import './styles.scss'
import React, { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'

import { useWindowSize } from 'hooks'
import Tooltip from './Tooltip'
import { getStaticImage } from 'utils/statics'
import { useSelector } from 'react-redux'

const SentimentTooltip = ({ className, isManual, value, score, position, onChange }) => {
  const { isActive } =  useSelector(store => store.modules.sentimentAnalysis)
  const modalPortal = document.getElementById('modal-portal')
  const iconRef = useRef(null)
  const [tooltip, setTooltip] = useState({ isOpen: false, coords: null })
  const [tooltipPosition, setTooltipPosition] = useState(position || 'bottom')
  const size = useWindowSize()

  useEffect(() => {
    if (tooltip.isOpen) {
      modalPortal.style.display = 'flex'
      setTooltip(prevState => ({ ...prevState, isOpen: true }))
    } else {
      modalPortal.style.display = 'none'
      setTooltip(prevState => ({ ...prevState, isOpen: false }))
    }

    return () => {
      modalPortal.style.display = 'none'
      setTooltip(prevState => ({ ...prevState, isOpen: false }))
    }
  }, [tooltip.isOpen])

  useEffect(() => {
    if(iconRef && iconRef.current) {
      setTooltip(prevState => ({
        ...prevState,
        coords: iconRef.current.getBoundingClientRect()
      }))
    }
  }, [iconRef, size, tooltip.isOpen])

  const toggle = () => {
    isActive && setTooltip(prevState => ({ ...prevState, isOpen: !prevState.isOpen }))
  }

  return (
    <div className={`sentiment-tooltip ${className ? className : ''}`}>
      <figure
        ref={iconRef}
        className={`sentiment-tooltip__icon ${isManual ? 'sentiment-tooltip__icon--primary-border' : ''}`}
        title={`${score * 100}%`}
        onClick={toggle}
      >
        <img src={getStaticImage(`/icons/orange-brand/${value}.svg`)} alt={value} />
      </figure>
      {tooltip.isOpen && tooltip.coords && ReactDOM.createPortal(
        <Tooltip
          modalPortal={modalPortal}
          toggle={toggle}
          coords={tooltip.coords}
          onChange={onChange}
          tooltipPosition={tooltipPosition}
          setTooltipPosition={setTooltipPosition}
        />, modalPortal
      )}
    </div>
  )
}

export default SentimentTooltip
